var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulbSzare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35388 3.69104L3.02819 2.36535C2.8451 2.18225 2.54844 2.18225 2.36535 2.36535C2.18225 2.54844 2.18225 2.8451 2.36535 3.02819L3.69104 4.35388C3.87413 4.53697 4.17078 4.53697 4.35388 4.35388C4.53697 4.17078 4.53697 3.87413 4.35388 3.69104Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 7.53125H0.46875C0.209656 7.53125 0 7.74091 0 8C0 8.25909 0.209656 8.46875 0.46875 8.46875H2.375C2.63409 8.46875 2.84375 8.25909 2.84375 8C2.84375 7.74091 2.63409 7.53125 2.375 7.53125Z",
    fill: "#CFCFCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 7.53125H13.625C13.3659 7.53125 13.1562 7.74091 13.1562 8C13.1562 8.25909 13.3659 8.46875 13.625 8.46875H15.5312C15.7903 8.46875 16 8.25909 16 8C16 7.74091 15.7903 7.53125 15.5312 7.53125Z",
    fill: "#CFCFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6346 2.36535C13.4515 2.18225 13.1549 2.18225 12.9718 2.36535L11.6461 3.69104C11.463 3.87413 11.463 4.17078 11.6461 4.35388C11.8292 4.53697 12.1259 4.53697 12.309 4.35388L13.6346 3.02819C13.8177 2.8451 13.8177 2.54847 13.6346 2.36535Z",
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C7.74091 0 7.53125 0.209656 7.53125 0.46875V2.375C7.53125 2.63409 7.74091 2.84375 8 2.84375C8.25909 2.84375 8.46875 2.63409 8.46875 2.375V0.46875C8.46875 0.209656 8.25909 0 8 0Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6252 4.69058C9.60336 3.88433 8.28145 3.59374 6.9877 3.90312C5.4877 4.24999 4.27836 5.44058 3.9127 6.93124C3.54707 8.43121 3.96895 9.94996 5.04704 11.0093C5.43145 11.3937 5.65645 11.9968 5.65645 12.6156V12.7187C5.65645 12.9812 5.86267 13.1875 6.1252 13.1875H9.8752C10.1377 13.1875 10.3439 12.9812 10.3439 12.7187V12.6156C10.3439 12.0062 10.5783 11.3843 10.9908 10.9812C11.7784 10.1843 12.2189 9.12499 12.2189 7.99999C12.2189 6.70624 11.6377 5.49683 10.6252 4.69058Z",
    fill: "#CFCFCF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 14.125V14.5938C6.125 15.3692 6.75581 16 7.53125 16H8.46875C9.24419 16 9.875 15.3692 9.875 14.5938V14.125H6.125Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbSzare);
export default __webpack_public_path__ + "static/media/lightbulb-szare.8326bf33e0ec28c1f4bf36695b67e95e.svg";
export { ForwardRef as ReactComponent };